// extracted by mini-css-extract-plugin
export default {"filter":"TypeFilter_filter__xsCrc"};